var InternalTransferRequest = function() {

	var comp = $('[data-component="internal-transfer-request"]');

		this.init = function() {

			$('#documentUploadLabel').on('keyup', function(e) {
				e.preventDefault();
			});

			$('.datepicker-input').datepicker({
				dateFormat: 'dd/mm/yy',
				dayNames: ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'],
				dayNamesMin: ['D','S','T','Q','Q','S','S','D'],
				dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb','Dom'],
				monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
				monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'],
				nextText: 'Próximo',
				prevText: 'Anterior'
			});

			formValidate();
			documentUpload();

		}

		function formValidate() {
			comp.find('#formInternalTransferRequest').validate({
				rules: {
					accountNumber: "required",
					amount: "required",
					valueDate: "required",
					beneficiaryAccount: "required",
					specialInstructions: "required",
					documentUploadLabel: "required"
				}
			});
		}

		function documentUpload(){
			$('#documentUpload').on('change', function() {
				var documentPath = $(this).val();
				documentPath = documentPath.split('\\').reverse()[0];
				console.log(documentPath)
				$('#documentUploadLabel').val(documentPath);
			});
		}

		return this.init();

	}
